module.exports = __webpack_public_path__ + "img/ramadan-behance.59004ee9.jpg";